import { useContext } from 'react';
import { ErrorHandlingContext } from '../error-handling.provider';

export const usePushError = () => {
    const { pushError } = useContext(ErrorHandlingContext);

    return { pushError };
};
